import React from 'react';
import ActionButton from '../../action-button';
import { useEditorHeaderContext } from '../context';

const PagesNavItem = ({ label, ...props }) => {
  const { isMd } = useEditorHeaderContext();

  return (
    <div className="ws-ui-editor-header__nav-item ws-ui-editor-header__nav-item--pages">
      <ActionButton
        {...props}
        label={isMd ? label : undefined}
        iconPlacement="before"
        iconGlyph={isMd ? undefined : 'pages'}
        format={isMd ? 'text' : 'solid-white'}
        size={isMd ? 'medium' : 'small'}
        fontWeight="regular"
      />
    </div>
  );
};

export default PagesNavItem;
